import m from 'mithril'

import blankPage from './images/journal-blank.jpg'
import tabImg from 'info/components/LogBook/images/tab-dirt.jpg'
import yellowPage from './images/yellow-reverse.png'

const ImgTemplate = (attrs) => {
  return {
    view: (vnode) => (
      <img
        className={`log-book-img ${attrs.classNames || ''}`}
        src={attrs.src}
        alt={attrs.alt || ''}
      />
    ),
  }
}

export default [
  {
    front: ImgTemplate({
      src: require('./images/journal-cover.png'),
      classNames: 'js-journal-cover mod-front',
    }),
    back: ImgTemplate({
      src: require('./images/journal-inside.png'),
      classNames: 'mod-back mod-mirror',
    }),
  },
  {
    front: require('./templates/01-page').default,
    back: require('./templates/01B-page').default,
    redactionID: 'intro-video',
  },
  {
    front: require('./templates/02-map').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabColor: '#c92c29',
    tabIndex: 0,
    tabText: 'Map',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-1',
    redactionID: 'intro-video',
  },
  {
    front: require('./templates/26-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 1,
    tabText: '',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-1',
    redactionID: 'intro-video',
    showSymbol: true,
  },
  {
    front: require('./templates/27-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 2,
    tabText: '',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-2',
    redactionID: 'intro-video',
    showSymbol: true,
    showGreenland: true
  },
  {
    front: require('./templates/03-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 3,
    tabText: '01',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-2',
    redactionID: 'outside-video-atutak',
  },
  {
    front: require('./templates/04-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 4,
    tabText: '02',
    redactionID: 'tunnel-entrance-video-tuk',
  },
  {
    front: require('./templates/05-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 5,
    tabText: '03',
    redactionID: 'tunnel-recroom-audio-tuk',
  },
  {
    front: require('./templates/06-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 6,
    tabText: '04',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-3',
    redactionID: 'recroom-video-poldi1',
  },
  {
    front: require('./templates/07-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 7,
    tabText: '05',
    redactionID: 'recroom-video-poldi2',
  },
  {
    front: require('./templates/08-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 8,
    tabText: '06',
    redactionID: 'recroom-video-freeman',
  },
  {
    front: require('./templates/09-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 9,
    tabText: '07',
    redactionID: 'recroom-video-soren1',
  },
  {
    front: require('./templates/10-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 10,
    tabText: '08',
    redactionID: 'recroom-video-soren2',
  },
  {
    front: require('./templates/11-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 11,
    tabText: '09',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-4',
    redactionID: 'quarters-video-soren1',
  },
  {
    front: require('./templates/12-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 12,
    tabText: '10',
    redactionID: 'quarters-video-soren2',
  },
  {
    front: require('./templates/13-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 13,
    tabText: '11',
    redactionID: 'quarters1-inuit-video',
  },
  {
    front: require('./templates/14-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 14,
    tabText: '12',
    redactionID: 'quarters-video-poldi',
  },
  {
    front: require('./templates/15-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 15,
    tabText: '13',
    redactionID: 'quarters2-inuit-video',
  },
  {
    front: require('./templates/23-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 16,
    tabText: '14',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-5',
    redactionID: 'headquarters1-video-major1',
  },
  {
    front: require('./templates/24-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 17,
    tabText: '15',
    redactionID: 'headquarters1-video-major2',
  },
  {
    front: require('./templates/25-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 18,
    tabText: '16',
    redactionID: 'headquarters1-video-general',
  },
  {
    front: require('./templates/16-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 19,
    tabText: '17',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-6',
    redactionID: 'tunnel-doctor-doctor',
  },
  {
    front: require('./templates/17-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 20,
    tabText: '18',
    tabImg: tabImg,
    tabImgOffset: 'mod-offset-7',
    redactionID: 'reactor1-reactor',
  },
  {
    front: require('./templates/18-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 21,
    tabText: '19',
    redactionID: 'reactor1-video-erik1',
  },
  {
    front: require('./templates/19-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 22,
    tabText: '20',
    redactionID: 'reactor1-video-erik2',
  },
  {
    front: require('./templates/20-page').default,
    back: ImgTemplate({
      src: blankPage,
      classNames: 'mod-back',
    }),
    hasTabs: true,
    tabIndex: 23,
    tabText: '21',
    redactionID: 'reactor2-general',
  },
    {
      front: require('./templates/21-page').default,
      back: ImgTemplate({
        src: blankPage,
        classNames: 'mod-back',
      }),
      hasTabs: true,
      tabIndex: 24,
      tabText: '22',
      tabImg: tabImg,
      tabImgOffset: 'mod-offset-1',
      redactionID: 'rails1-video-tuk',
    },
    {
      front: require('./templates/22-page').default,
      back: ImgTemplate({
        src: blankPage,
        classNames: 'mod-back',
      }),
      hasTabs: true,
      tabIndex: 25,
      tabText: '23',
      redactionID: 'rails1-video-william',
    },    
  {
    front: ImgTemplate({
      src: require('./images/journal-inside.png'),
      classNames: 'mod-front',
    }),
  },
]
